module.exports = __webpack_public_path__ + "img/__icon_TANDEM ZESTAW.b9df3dd1.svg";